import { z } from 'zod'

import SelectBase from '@/components/Form/Atoms/SelectBase/SelectBase'
import FormResolverUtils from '@/utils/FormResolverUtils'
import { InputKey } from '@/utils/inputKey'

export const deliveryIntervalDefaultValue = '30'

const formResolverUtils = FormResolverUtils({ schema: z.string(), i18nName: '配送間隔' })

const deliveryIntervals = new Array(5).fill(null).map((_, i) => i * 30 + 30)
const values = Object.fromEntries(
  deliveryIntervals.map((deliveryInterval) => {
    return [deliveryInterval, deliveryInterval]
  })
)

const options = deliveryIntervals.map((deliveryInterval) => {
  return { label: `${deliveryInterval}日毎にお届け`, value: `${deliveryInterval}` }
})

export const deliveryIntervalInputKey = InputKey('deliveryInterval', formResolverUtils.enum(values).schema)

const DeliveryIntervalInput = () => {
  return <SelectBase name={deliveryIntervalInputKey.name} options={options} />
}

export default DeliveryIntervalInput
